import type { LoginPayload } from '@/services/auth'

export type SupportLoginInput = {
  email?: string | null
  username?: string | null
  phone?: string | null
  password: string
  serviceInstanceId?: string | null
}

export const getSupportLoginAttemptErrorMessage = (error: unknown) => {
  if (error instanceof Error) {
    return error.message
  }

  return String(error ?? '').trim() || 'Login failed'
}

export const isSupportLoginDisabledMessage = (message: string) => {
  const normalized = message.trim().toLowerCase()
  if (!normalized) return false

  return normalized.includes('login not allowed')
    || normalized.includes('login with email is not allowed')
    || normalized.includes('login with username is not allowed')
    || normalized.includes('login with phonenumber is not allowed')
    || normalized.includes('login with phone number is not allowed')
}

export const resolveSupportLoginFailureMessage = (attemptMessages: string[], fallback: unknown) => {
  const normalizedMessages = attemptMessages
    .map((value) => String(value ?? '').trim())
    .filter(Boolean)

  if (normalizedMessages.length > 0 && normalizedMessages.every(isSupportLoginDisabledMessage)) {
    return 'Login is disabled for this organisation. Enable at least one login method (email, username, or phone).'
  }

  return getSupportLoginAttemptErrorMessage(fallback)
}

export const buildSupportLoginAttempts = (input: SupportLoginInput): LoginPayload[] => {
  const email = String(input.email ?? '').trim()
  const username = String(input.username ?? '').trim()
  const phone = String(input.phone ?? '').trim()
  const password = String(input.password ?? '').trim()
  const serviceInstanceId = String(input.serviceInstanceId ?? '').trim()

  const scoped = serviceInstanceId ? { service_instance_id: serviceInstanceId } : {}

  return [
    ...(email
      ? [
          { email, password, ...scoped },
          { email, password },
        ]
      : []),
    ...(username
      ? [
          { type: 'username' as const, username, password, ...scoped },
          { type: 'username' as const, username, password },
        ]
      : []),
    ...(phone
      ? [
          { type: 'phn_nbr' as const, phn_nbr: phone, password, ...scoped },
          { type: 'phn_nbr' as const, phn_nbr: phone, password },
        ]
      : []),
  ]
}
